import React from "react";
import { useTranslation } from "react-i18next";

export function UnknownURL() {
    const { t } = useTranslation();
    return (
        <div className="mt-24 w-full h-full flex flex-col items-center justify-center">
            <h1>{t("404-title")}</h1>
            <p>{t("404-text")}</p>
        </div>
    );
}
